import { appStore } from "./AppMobx";
import { localLargeStorage } from "./LocalLargeStorage";
import printifyService from "./PrintifyService";

let _globalInitDone = false;
export function globalInitDone() {
	return _globalInitDone;
}

export async function globalInit() {
	await localLargeStorage.initDB();
	await printifyService.init();
	await appStore.init();
	_globalInitDone = true;
}
